import { render, staticRenderFns } from "./block-template-general-info.vue?vue&type=template&id=7af71ef6&scoped=true&lang=pug"
import script from "./block-template-general-info.vue?vue&type=script&lang=js"
export * from "./block-template-general-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af71ef6",
  null
  
)

export default component.exports